import { useServiceVehiclesOperations } from './useServiceVehiclesOperations';
import { useServiceVehicleOperations } from './useServiceVehicleOperations';

export { useServiceVehiclesOperations, useServiceVehicleOperations };
